import React, { useEffect, useState } from "react";
import api from "../../api";
import "../../css/Dashboard.css"; // Ensure this file exists at the specified path
import { showErrorToast } from "../../utils/toastUtils"; // Optional toast notifications
import ChartInfoPopup from "./ChartInfoPopup";

const BotPerformance = () => {
  const [performanceData, setPerformanceData] = useState([
    { label: "Accuracy", value: 0 },
    { label: "Speed", value: 0 },
    { label: "User Satisfaction", value: 0 },
    { label: "Engagement", value: 0 },
  ]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPerformance = async () => {
      try {
        const token = localStorage.getItem("access_token");

        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/chat/bot-performance`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { accuracy, speed, efficiency, engagement } = res.data;

        // console.log(res.data);

        setPerformanceData([
          { label: "Accuracy", value: accuracy || 0 },
          { label: "Speed", value: speed || 0 },

          { label: "Engagement", value: engagement || 0 },
          { label: "Efficiency", value: efficiency || 0 },
        ]);
      } catch (error) {
        console.error("Error fetching bot performance:", error);
        // showErrorToast("Failed to fetch bot performance");
      } finally {
        setLoading(false);
      }
    };

    fetchPerformance();
  }, []);

  return (
    <div className="chart-card p-3 shadow-sm rounded mb-4 profile-i d-flex flex-column">
      <div className="d-flex align-items-center gap-2 mb-3">
        <h5 className="fw-semibold m-0">
          <span className="border-start border-4 ps-2 ak-text-lg d-flex align-content-center">
            Bot Performance
          </span>
        </h5>

        <div className="chart-info-anchor">
          <ChartInfoPopup text="Shows the chatbot’s speed, accuracy, and engagement to track overall efficiency and effectiveness." />
        </div>
      </div>

      {loading ? (
        <div className="text-center py-4">
          <div
            style={{ fontSize: "small" }}
            className="spinner-border text-dark"
            role="status"
          ></div>
          <p className="mt-2 mb-0">Loading Performance...</p>
        </div>
      ) : (
        performanceData.map((item, index) => (
          <div key={index} style={{ fontSize: "small" }} className="mb-2">
            <div className="d-flex justify-content-between">
              <span style={{ fontSize: "small" }} className="">
                {item.label}
              </span>
              <span style={{ fontSize: "small" }} className="text-muted">
                {item.value}%
              </span>
            </div>
            <div
              className="progress"
              style={{
                height: "8px",
                backgroundColor: "#e0e0e0",
                borderRadius: "10px",
              }}
            >
              <div
                className="progress-bar bg-dark"
                role="progressbar"
                style={{ width: `${item.value}%`, borderRadius: "10px" }}
                aria-valuenow={item.value}
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>

            {/* Bottom percentage scale */}
            <div className="d-flex justify-content-between">
              <small className="text-muted">0%</small>
              <small className="text-muted">100%</small>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default BotPerformance;
